module.exports = __webpack_public_path__ + "img/marker.a9df1451.png";